import * as yup from 'yup'

export const haraSocialValidation = yup.object().shape({
  content: yup.string().max(160, 'No more than 160 characters'),
  type: yup.string().required('Last name is required'),
})
